import { defaultHttpClient } from '../../httpClient';
import type { AgeFiltersResponse } from '../types';

// 인기 검색어 연령 필터
export const getAgeFilters = async () => {
  return defaultHttpClient
    .request<AgeFiltersResponse>({
      method: 'GET',
      url: '/api/v2/search/popular_queries/filter_options/',
    })
    .then(result => result.data);
};
